import {
  PERFIL_USUARIO_GET_BY_ID,
  PERFIL_USUARIO_CREATE,
  PERFIL_USUARIO_UPDATE,
  PERFIL_USUARIO_REMOVE,
  PERFIL_USUARIO_PLANOS_LIST,
  PERFIL_USUARIO_VINCULAR_TODOS_PLANOS,
  PERFIL_USUARIO_DESVINCULAR_TODOS_PLANOS
} from "../actions/perfilUsuario";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

const actions = {
  [PERFIL_USUARIO_GET_BY_ID]: ({ dispatch }, idperfil) => {
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .getById(idperfil)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PERFIL_USUARIO_CREATE]: ({ dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .create(payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PERFIL_USUARIO_UPDATE]: ({ dispatch }, { idperfil, payload }) => {
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .update(idperfil, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PERFIL_USUARIO_REMOVE]: ({ dispatch }, idperfil) => {
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .remove(idperfil)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PERFIL_USUARIO_PLANOS_LIST]: ({ dispatch, getters }, idfornecedor) => {
    const fornecedorId = idfornecedor || getters.getFornecedorId;
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .getPlanosPagamento(fornecedorId)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PERFIL_USUARIO_VINCULAR_TODOS_PLANOS]: (
    { dispatch },
    { idperfil, params, body }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .vincularTodosPlanos(idperfil, { params: params || {}, body })
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [PERFIL_USUARIO_DESVINCULAR_TODOS_PLANOS]: ({ dispatch }, idperfil) => {
    return new Promise((resolve, reject) => {
      Api.v4.perfilUsuario
        .desvincularTodosPlanos(idperfil)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
